import React from 'react';
import { CheckCircle, Star, Users } from 'lucide-react';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
                <div className="header-logo">
            <img 
            src="/img/atento-logo.png" 
            alt="Arauclin Logo" 
            className="header-logo-img"
            />
        </div>
        <div className="header-content">
          <div className="header-text">
            <h1 className="header-title">
              Clínica de Saúde Ocupacional
            </h1>
            <p className="header-subtitle">
              Excelência em Medicina e Segurança do Trabalho desde 1995
            </p>
            <div className="header-features">
              <div className="feature-item">
                <CheckCircle className="feature-icon" />
                <span>Médicos Especialistas</span>
              </div>
              <div className="feature-item">
                <Star className="feature-icon" />
                <span>Estrutura Moderna</span>
              </div>
              <div className="feature-item">
                <Users className="feature-icon" />
                <span>Atendimento Personalizado</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </header>
  );
};

export default Header;